import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowWorkTeam, WorkflowWorkTeamMember } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class WorkTeamsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/work-teams`;
  }

  async getWorkTeams(): Promise<WorkflowWorkTeam[]> {
    return await this.get<WorkflowWorkTeam[]>('');
  }

  async getWorkTeamMembers(): Promise<WorkflowWorkTeamMember[]> {
    return await this.get<WorkflowWorkTeamMember[]>('members');
  }

  async createWorkTeam(workTeam: WorkflowWorkTeam): Promise<string> {
    return await this.postWithResult<WorkflowWorkTeam, string>('', workTeam);
  }

  async updateWorkTeam(workTeam: WorkflowWorkTeam): Promise<void> {
    return await this.put('', workTeam);
  }

  async deleteWorkTeam(id: string): Promise<void> {
    return await this.delete(`${id}`);
  }
}
